/**
 * Lightbox
 */

export default function initLightbox(){
	document.querySelectorAll('[data-cs-lightbox]').forEach(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault();

			const imgSrc = this.getAttribute('href');
			const alt = this.querySelector('img')?.getAttribute('alt') || '';

			const overlay = document.createElement('div');
			overlay.className = 'lightbox-overlay';
			overlay.setAttribute('role', 'dialog');
			overlay.setAttribute('aria-label', 'Enlarged image');
			overlay.setAttribute('aria-modal', 'true');
			overlay.setAttribute('tabindex', '-1');

			const closeBtn = document.createElement('button');
			closeBtn.setAttribute('type', 'button');
			closeBtn.setAttribute('aria-label', 'Close');
			closeBtn.className = 'lightbox-overlay__close';
			closeBtn.textContent = '×';

			const imageContainer = document.createElement('div');
			imageContainer.className = 'lightbox-overlay__image-container';

			const figure = document.createElement('figure');
			figure.className = 'lightbox-overlay__figure';

			const img = document.createElement('img');
			img.src = imgSrc;
			img.alt = alt;
			img.className = 'lightbox-overlay__image';

			figure.appendChild(img);
			imageContainer.appendChild(figure);
			overlay.appendChild(closeBtn);
			overlay.appendChild(imageContainer);

			const closeLightbox = () => {
				overlay.classList.add('is-closing');
				overlay.addEventListener('animationend', () => {
					if (overlay.parentNode) {
						overlay.parentNode.removeChild(overlay);
					}
				}, { once: true });
			};

			overlay.addEventListener('click', closeLightbox);
			closeBtn.addEventListener('click', closeLightbox);
			overlay.addEventListener('keydown', (e) => {
				if ( e.key==='Escape' ) closeLightbox();
			});

			document.body.appendChild(overlay);
			overlay.focus();
		});
	});
}